<template>
  <div class="title-without-link" v-if="!isTitleReco">
    <h2>{{text}}</h2>
    <div class="separator" v-if="hasBlock"></div>
  </div>
  <div v-else class="treatment-title">
    <h2>{{text}}</h2>
    <div class="separator" v-if="hasBlock"></div>
    <print-button/>
  </div>
</template>

<script>
  import PrintButton from "./PrintButton"

  export default {
    name: "TitleSimple",
    props: ['text', 'hasBlock', 'isTitleReco'],
    components: {
      PrintButton
    }
  }
</script>

<style lang="scss">
  .title-without-link {
    h2 {
      font-size: rem(22px);
      line-height: rem(24px);
      margin: 0 rem(20px) 0 0;

      @include mq($until: MD) {
        font-size: rem(18px);
      }
    }

    .separator {
      position: relative;
      padding-bottom: rem(25px);
      margin: 0 0 rem(30px);

      &::after {
        position: absolute;
        content: '';
        left: 0;
        bottom: 0;
        height: 1px;
        width: 100%;
        background-color: color(border);
        -webkit-print-color-adjust: exact;
      }

      @include mq($until: MD) {
        margin: 0 0 rem(20px);
        padding-bottom: rem(15px);
      }
    }
  }
</style>